import { Button, Text, WarningIcon } from '@viapeople/components'
import { useNavigate, useParams } from 'react-router-dom'

interface CalibrationErrorProps {
	error?: Error | null
	refetch?: () => void
}

export function CalibrationError({ error, refetch }: CalibrationErrorProps) {
	const navigate = useNavigate()
	const { cycleId } = useParams<{ cycleId: string }>()

	return (
		<main className='w-full p-6'>
			<div className='flex items-center justify-center py-8'>
				<div className='text-center'>
					<WarningIcon className='w-12 h-12 mx-auto mb-4 text-red-400' />
					<Text className='mb-2'>Failed to load calibration data</Text>
					<Text variant='small' className='text-gray-600 mb-4'>
						{error?.message || 'An unexpected error occurred'}
					</Text>
					<div className='flex gap-2 justify-center'>
						<Button variant='secondary' onClick={() => navigate(`/cycles/${cycleId}`)}>
							Back to Cycle
						</Button>
						{refetch && (
							<Button variant='primary' onClick={() => refetch()}>
								Try Again
							</Button>
						)}
					</div>
				</div>
			</div>
		</main>
	)
}
